var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2716 104.02C9.30791 109.99 0.994812 137.307 0.0912144 140.382C-0.270225 141.829 0.452652 143.457 2.07913 143.819C2.25985 143.819 2.62129 144 2.80201 144C2.98273 144 3.34416 144 3.52488 143.819C6.59712 142.915 33.8857 134.593 39.8495 128.623C46.7168 121.749 46.7168 110.714 39.8495 104.02C33.1629 97.3266 22.139 97.3266 15.2716 104.02Z",
    fill: "url(#paint0_linear_371_154)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M142.166 5.07517C141.806 3.45461 140.545 2.37423 138.925 1.83404C131.902 0.393543 124.52 -0.146645 117.317 0.033418C90.3079 0.033418 74.1023 14.4384 62.0381 33.5251H34.8486C30.167 33.7051 26.0256 36.4061 23.6848 40.3674L10.7202 66.2965C10.3601 67.1968 10.1801 68.0971 10 69.1775C10 72.5986 12.881 75.4797 16.3022 75.4797H43.4916L37.7296 81.2416C34.4885 84.4828 34.4885 89.7046 37.7296 93.1258L51.0543 106.45C54.2954 109.692 59.5172 109.692 62.9384 106.45L68.8805 100.508V127.698C68.8805 131.119 71.5814 134 75.1827 134C76.083 134 76.9833 133.82 77.8836 133.46L103.633 120.495C107.774 118.154 110.295 114.013 110.475 109.331V81.7818C129.562 69.7177 143.967 53.512 143.967 26.6827C144.147 19.4802 143.606 12.2777 142.166 5.07517ZM110.475 43.9687C104.713 43.9687 100.031 39.2871 100.031 33.5251C100.031 27.7631 104.713 23.0814 110.475 23.0814C116.237 23.0814 120.919 27.7631 120.919 33.5251C120.919 39.2871 116.237 43.9687 110.475 43.9687Z",
    fill: "url(#paint1_linear_371_154)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_371_154",
    x1: 1.25662,
    y1: 144,
    x2: 65.6501,
    y2: 112.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD01",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#F87F39",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#F05A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EB426F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF1995"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_371_154",
    x1: -130.351,
    y1: 280.14,
    x2: 202.49,
    y2: 103.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#F87F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#F05A5A",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EB426F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF1995"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookIcon);
export default __webpack_public_path__ + "static/media/book-icon.60afbb0068e2da665e7c2d3500f544c4.svg";
export { ForwardRef as ReactComponent };